import { render, staticRenderFns } from "./PdfCanvas.vue?vue&type=template&id=6e608258"
import script from "./PdfCanvas.vue?vue&type=script&lang=js"
export * from "./PdfCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports